import { clearAuthStorage } from 'utils/storage';

/**
 * 다중 기기 접속 방지: HTTP Status 401 + Error Code 'SINGLE_DEVICE_SESSION_EXPIRED'
 * 전역에서 1회만 실행: 저장소/쿠키 제거 → 알림 → 로그인 페이지 이동
 */
const LOGIN_PAGE_PATH = '/login';
export const SINGLE_DEVICE_SESSION_EXPIRED_CODE = 'SINGLE_DEVICE_SESSION_EXPIRED'; // 다중 기기 접속 방지 코드

type WindowWithSessionExpiry = Window & {
  SINGLE_DEVICE_SESSION_EXPIRED_HANDLED: boolean;
  openCommonAlert: (message: string, onClose: () => void, options?: { disableBackdropClick?: boolean }) => void;
};

const getWindow = (): WindowWithSessionExpiry | undefined => {
  return typeof window === 'undefined' ? undefined : (window as unknown as WindowWithSessionExpiry);
};

export const isSingleDeviceSessionExpiredAlreadyHandled = (win?: WindowWithSessionExpiry): boolean => {
  const window = win ?? getWindow();
  return window?.SINGLE_DEVICE_SESSION_EXPIRED_HANDLED === true;
};

const setSingleDeviceSessionExpiredHandled = (win: WindowWithSessionExpiry): void => {
  win.SINGLE_DEVICE_SESSION_EXPIRED_HANDLED = true;
};

const redirectToLogin = (): void => {
  window.location.replace(LOGIN_PAGE_PATH);
};

// 알림 띄우고 재로그인 유도 (로그인 페이지로 강제 이동)
const showAlertAndRedirect = (win: WindowWithSessionExpiry, message: string): void => {
  win.openCommonAlert(message, redirectToLogin, { disableBackdropClick: true });
};

/**
 * 세션 강제 만료 시 1회만 실행 (다른 기기 로그인 감지용)
 * @param errorMessage - API 응답의 errorMessage ("다른 기기에서 로그인하여 현재 세션이 만료되었습니다.")
 */
export const handleSingleDeviceSessionExpired = (errorMessage: string): void => {
  const win = getWindow();
  if (!win) return;
  if (isSingleDeviceSessionExpiredAlreadyHandled(win)) return;

  setSingleDeviceSessionExpiredHandled(win);
  clearAuthStorage();
  showAlertAndRedirect(win, errorMessage);
};
